import MetaData from "@/components/seo/MetaData";
import en from "@/localization/en.json";

function PrivacyPolicy() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/privacy-policy`;

  return (
    <>
      <MetaData url={pageUrl} />
      <div className="px-[2rem] lg:px-[7.5rem] pt-[4rem] pb-[7.5rem]">
        <h1 className="text-[ #0A101A] font-semibold text-[2.625rem]">
          Privacy Policy
        </h1>

        <p className="text-[#1F2A3B] text-[1rem] mt-[2.25rem]">
          Last updated: 13 February, 2023
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          Please ensure that you read our Privacy Agreement, which applies to
          your visit to the site. Your usage of the site and the personal
          information/data you supply to us will be treated in strict confidence
          in accordance with the Privacy Agreement and any and all applicable
          laws and regulations. Please refrain from using the site if you
          disagree with how your information is shared or used in accordance
          with the Privacy Agreement.
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          Our policy entails how we accumulate, utilize, disclose, and preserve
          the information related to our service, including the discretion of
          gathering and applying the information. We are dedicated as a company
          to respecting and securing the privacy of everyone with whom we
          engage. We are honest and transparent in our treatment of personal
          information and process it in line with relevant privacy and data
          protection regulations at all times. This policy also highlights the
          alternatives you have when it comes to how we manage your data.
        </p>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            The information we collect
          </p>

          <p>
            We collect personal information to the degree of our requirements to
            offer service to you. In order to improve our service, we also track
            website usage and client traffic patterns. We will only gather data
            that we deem essential and applicable to providing you with the
            website&apos;s services. This includes your IP address, browser
            version, browser type, the pages you visit on our website, the date,
            time, and duration of the visit, and other data that are
            automatically recorded by the machines and software to analyze it
            for troubleshooting issues, also known as diagnostic data.
          </p>

          <div>
            <p>
              When you use our website to make purchases, personally
              identifiable data about you may be gathered, including:
            </p>

            <ul className="list-disc mt-[10px] ml-[20px]">
              <li>Your initials</li>
              <li>Email addresses</li>
              <li>Contact information</li>
              <li>Postal code</li>
              <li>
                Your thoughts on the services, goods, and functions offered by
                our websites
              </li>
            </ul>
          </div>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Cookies</p>

          <p>
            To enhance our service and user experience, we collect minor data
            sent by the web server to the web browser and stored on the device.
            The data includes visitor preferences, session information,
            user-specific information, and any past activity. This allows the
            website to recognize and monitor web browsers and also to provide
            the best experience to users while navigating through our website.
            It should be considered that turning off cookies may impair your
            ability to use our services.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            How we use this information
          </p>

          <p>
            For business purposes, we collect, utilize, handle, and distribute
            the data you provide. We utilize your information to help you with
            transactional needs like order fulfillment and safe product
            delivery. Your input may be used by us to enhance our websites and
            services, including customizing them to better suit your
            requirements. Users get notifications upon registration and updates
            regarding the progress of their orders.
          </p>

          <p>
            AmarPet may send promotional materials and special offer
            notifications through a variety of methods, such as email, text
            messages, advertisements on social media platforms, and other
            digital channels. We may analyze the data collected from various
            online sources and your personal devices to personalize our
            marketing communications according to your preferences.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            How long we keep your information
          </p>

          <p>
            Your information and personal data may be delivered through our own
            platform, which is hosted on a dedicated server. It might be sent to
            government bodies in response to requests from law enforcement
            agencies. Agreeing to the privacy policy represents your approval of
            the transfer of such information. AmarPet takes all the necessary
            precautions to ensure that your personal data is handled with
            security by following the privacy policy measures and making sure
            that no data is transferred to another country or organization
            without appropriate control.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            Disclosure for law enforcement
          </p>

          <p>
            AmarPet may be obliged to reveal your information under some
            circumstances, such as where it is required by law or in response to
            lawful demands from public authorities, including courts and
            government agencies.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Legal Requirements</p>

          <div>
            <p>
              AmarPet may be required to disclose your personal information if
              such disclosure is necessary for the following purposes:
            </p>

            <ul className="list-disc mt-[10px] ml-[20px]">
              <li>To preserve and defend AmarPet&apos;s property or rights.</li>
              <li>To follow through on a legal commitment. </li>
              <li>
                To impede or scrutinize potential misbehavior related to
                AmarPet’s service.
              </li>
              <li>To preserve the individual security of our users.</li>
              <li>To safeguard from legal repercussions.</li>
            </ul>
          </div>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Data Security</p>

          <p>
            We employ appropriate data collection, storage, and processing
            techniques and security measures to protect your personal records
            from unauthorized access, alteration, disclosure, or destruction.
            However, it must be acknowledged that transmission of data through
            the internet or computer storage is not completely protected.
            Although we make every effort to secure your private information
            using reasonable techniques, we cannot guarantee its total
            protection.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            Retaining User Content
          </p>

          <p>
            AmarPet may preserve your personal data and profile information
            after deletion or deactivation of your account for a justifiable
            period of time and following a good basis for the purpose.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">
            Changes to Privacy Policy
          </p>

          <p>
            We may update the privacy policy from time to time to ensure that it
            is accurate and represents how we utilize users&apos; personal
            information. AmarPet shall adopt all reasonable measures to inform
            you if there is a significant change in the way we process your
            information that may affect your privacy. It is recommended to stay
            up-to-date on the privacy policy announcements, as the changes
            updated here will be immediately effective.
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Contact Us </p>

          <p>{en["privacyPolicy.contact_us_1"]}</p>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
